import { useContext, useEffect, useState } from 'react';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs, { Dayjs } from 'dayjs';
import { TextFieldComponent } from '../../core/_models';

export function TimeComponent({
  context,
  config,
}: TextFieldComponent) {
  const { id, title, value, onChange } = config;

  const formContext = useContext(context);

  const [v, setValue] = useState<Dayjs | null>(() => {
    if (!value) return null;

    const parsedValue = dayjs(value, ['HH-mm', 'HH:mm', 'YYYY-MM-DD HH:mm:ss']);

    return parsedValue.isValid() ? parsedValue : null;
  });

  useEffect(() => {
    if (!value) {
      setValue(null);
      formContext.set(id, null);
      return;
    }

    const parsedValue = dayjs(value, ['HH-mm', 'HH:mm', 'YYYY-MM-DD HH:mm:ss']);

    if (!parsedValue.isValid()) {
      return;
    }

    setValue(parsedValue);
    formContext.set(id, parsedValue.format('HH:mm'));
  }, [value, id, formContext]);

  const handleChange = (newValue: Dayjs | null) => {
    if (!newValue || !newValue.isValid()) {
      setValue(null);
      formContext.set(id, null);
      return;
    }

    const formattedValue = newValue.format('HH:mm');

    setValue(newValue);
    formContext.set(id, formattedValue);

    if (onChange) {
      formContext.submit({ onChange });
    }
  };

  return (
    <TimePicker
      label={title.text || 'Time'}
      value={v}
      onChange={handleChange}
      ampm={false}
      format="HH:mm"
    />
  );
}
